export default __webpack_public_path__ + "static/media/Dapazin-5_Ban.b6d94cea.jpg";